query GetEventYouTubeSpeed($eventId: ID!) {
  speed: StreamToolsGetEventYouTubeSpeed(eventId: $eventId) {
    eventId
    level
    appDefaultLevel
    effectiveLevel
    liveAllowed
    brakeCapLevel
    updatedAt
  }
}
